'use es6';

import uniqueId from 'transmute/uniqueId';
import RecordFactory from '../RecordFactory';
import { AdWordsKeywordTypes, AdWordsStatusMap } from '../../lib/Constants';
import AdWordsBiddingStrategyConfigurationEntityRecord from './AdWordsBiddingStrategyConfigurationEntityRecord'; // https://git.hubteam.com/HubSpot/Ads/blob/master/AdsBase/src/main/java/com/hubspot/ads/data/adwords/AbstractKeywordView.java

export default RecordFactory({
  id: null,
  adGroupId: null,
  adGroupName: null,
  campaignId: null,
  status: AdWordsStatusMap.ENABLED,
  keywordText: '',
  matchType: AdWordsKeywordTypes.PHRASE,
  maxCpc: null,
  negative: null,
  finalUrl: null,
  finalMobileUrl: null,
  biddingStrategyConfiguration: new AdWordsBiddingStrategyConfigurationEntityRecord({}),
  // TODO: SHould be record
  servingStatus: null,
  previousState: null,

  toString() {
    switch (this.matchType) {
      case AdWordsKeywordTypes.PHRASE:
        return `"${this.keywordText}"`;

      case AdWordsKeywordTypes.EXACT:
        return `[${this.keywordText}]`;

      case AdWordsKeywordTypes.BROAD:
      default:
        return this.keywordText;
    }
  }

}, () => {
  return {
    id: `${uniqueId() * -1}`
  };
});